/* ============================================================
   AURALIGN — Product Detail Page engine
   Shared across all 4 PDPs. Per-product data comes from window.PDP.
   ============================================================ */
(function () {
'use strict';

/* Per-product data is injected by the product template as window.PDP;
   window.ASSETS resolves shared image filenames to local theme asset URLs.
   Everything else in this file is the shared PDP engine. */
const P = window.PDP || {};
const A = window.ASSETS || {};
const money = n => '$' + Number(n || 0).toFixed(0);

const IJEWEL_MODELS = P.models || {};
const IMAGES        = P.images || {};
const VARIANTS      = P.variants || {};
const COLORS        = P.colors || ['Gold', 'Rose Gold', 'Silver'];
const FINISH_LABEL  = P.finishLabel || { 'Gold': 'Gold Vermeil', 'Rose Gold': 'Rose Gold', 'Silver': '925 Silver' };
const SWATCH        = { 'Gold': 'gold', 'Rose Gold': 'rose', 'Silver': 'silver' };
const PLAIN         = P.plain || {};
const SIZES         = P.sizes || [];
const HAS_SIZE      = SIZES.length > 0;
const shortSize = s => String(s || '').replace(' (Adjustable)', '');

/* The four-piece system — the upsell row lists whichever pieces aren't
   the product on screen. */
const PRODUCTS = [
  { key: 'ring', name: 'AURALIGN Ring', meridian: 'Fingertip meridian line',
    cardImg: { Gold: 'custom-hp-ring.webp', 'Rose Gold': 'custom-hp-ring.webp', Silver: 'custom-hp-ring.webp' },
    variants: { Gold: { price: 188, compare: 238 }, 'Rose Gold': { price: 188, compare: 238 }, Silver: { price: 168, compare: 208 } },
    handle: 'auralign-ring' },
  { key: 'bracelet', name: 'AURALIGN Bracelet', meridian: 'Wrist & circulatory line',
    cardImg: { Gold: 'custom-hp-bracelet.webp', 'Rose Gold': 'custom-hp-bracelet.webp', Silver: 'custom-hp-bracelet.webp' },
    variants: { Gold: { price: 348, compare: 438 }, 'Rose Gold': { price: 348, compare: 438 }, Silver: { price: 318, compare: 398 } },
    handle: 'auralign-bracelet' },
  { key: 'necklace', name: 'AURALIGN Necklace', meridian: 'Throat & heart line',
    cardImg: { Gold: 'custom-hp-necklace.webp', 'Rose Gold': 'custom-hp-necklace.webp', Silver: 'custom-hp-necklace.webp' },
    variants: { Gold: { price: 348, compare: 438 }, 'Rose Gold': { price: 348, compare: 438 }, Silver: { price: 318, compare: 398 } },
    handle: 'auralign-necklace' },
  { key: 'earrings', name: 'AURALIGN Earrings', meridian: 'Cranial & nervous line',
    cardImg: { Gold: 'custom-hp-earrings.webp', 'Rose Gold': 'custom-hp-earrings.webp', Silver: 'custom-hp-earrings.webp' },
    variants: { Gold: { price: 208, compare: 258 }, 'Rose Gold': { price: 208, compare: 258 }, Silver: { price: 188, compare: 238 } },
    handle: 'auralign-earrings' }
];
const UPSELL = PRODUCTS.filter(p => p.key !== P.key).map(p => ({
  name: p.name, meridian: p.meridian, cardImg: p.cardImg, variants: p.variants, handle: p.handle
}));

/* Progressive bundle discount — % off keyed to total AURALIGN piece quantity in cart.
   Backed by four Shopify automatic discounts created via Admin API (titles:
   "AURALIGN Bundle 5/10/15/20%"). They're product-scoped to the 4 AURALIGN
   handles and non-combining, so Shopify always picks the best one for the
   customer. cart.total_discount in /cart.js reflects what actually applies. */
const BUNDLE_TIERS = [
  { min: 2, pct: 5 },
  { min: 3, pct: 10 },
  { min: 4, pct: 15 },
  { min: 5, pct: 20 }
];
function tierPct(qty) {
  let pct = 0;
  for (const t of BUNDLE_TIERS) if (qty >= t.min) pct = t.pct;
  return pct;
}
const TICKER = ['4-layer vermeil plating', 'Free signature gift box', 'USPS tracked shipping', 'Lifetime warranty', 'Hypoallergenic & nickel-free', '90-day trial', 'Ethically made', 'Water resistant'];

const BX_ICON = {
  point: '<circle cx="12" cy="12" r="2.3" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="6.2"/><path d="M12 2.4v2.3M12 19.3v2.3M21.6 12h-2.3M4.7 12H2.4"/>',
  gem: '<path d="M12 3.6 4.8 9 12 20.4 19.2 9z"/><path d="M4.8 9h14.4M9 3.6 12 9 9 20.4M15 3.6 12 9l3 11.4"/>',
  loop: '<path d="M12 12c1.6-2.4 3.1-3.5 5-3.5a3.5 3.5 0 0 1 0 7c-1.9 0-3.4-1.1-5-3.5zM12 12c-1.6 2.4-3.1 3.5-5 3.5a3.5 3.5 0 0 1 0-7c1.9 0 3.4 1.1 5 3.5z"/>',
  wave: '<path d="M3 13q2.3-6.6 4.5 0t4.5 0 4.5 0 4.5 0"/><path d="M3 18h18" opacity=".4"/>',
  moon: '<path d="M20.5 14.3A8.6 8.6 0 0 1 9.7 3.5 8.6 8.6 0 1 0 20.5 14.3z"/><path d="M16.5 4.2l.7 1.6 1.6.7-1.6.7-.7 1.6-.7-1.6-1.6-.7 1.6-.7z" fill="currentColor" stroke="none"/>',
  people: '<circle cx="9" cy="8.4" r="3.1"/><path d="M3.4 19a5.6 5.6 0 0 1 11.2 0"/><path d="M16.2 6a3.1 3.1 0 0 1 0 5.8M20.6 19a5.6 5.6 0 0 0-3.9-5.3"/>',
  nodes: '<circle cx="6" cy="7" r="2.4"/><circle cx="18" cy="7" r="2.4"/><circle cx="12" cy="17.4" r="2.4"/><path d="M7.9 8.7l3 6.6M16.1 8.7l-3 6.6M8.4 7h7.2"/>',
  stack: '<path d="M12 3.2 21 8l-9 4.8L3 8z"/><path d="M3.4 12.4 12 17l8.6-4.6M3.4 16.2 12 20.8l8.6-4.6" opacity=".5"/>',
  tag: '<path d="M3.6 12.6V4.6c0-.6.4-1 1-1h8l8 8c.4.4.4 1 0 1.4l-6.6 6.6c-.4.4-1 .4-1.4 0z"/><circle cx="8" cy="8" r="1.6"/>'
};
const BXTABS = P.bxTabs || [];
const LAUREL = '<svg class="proofbadge__laurel" viewBox="0 0 20 32" width="14" height="22" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"><path d="M14.5 3C9.5 7.5 6.5 13.5 6.5 20s3 9 3 9"/><path d="M12.5 8c-4.2 0-6.3 2.2-6.3 2.2M13 13c-4.2 0-6.3 2.2-6.3 2.2M12.6 18.3c-3.6 0-5.5 2-5.5 2M11.5 23.4c-3.2 0-4.6 2-4.6 2"/></svg>';

/* ---------- icons ---------- */
const ICON = {
  shipping: '<path d="M3 8h10v8H3z"/><path d="M13 11h4l3 3v2h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>',
  trial: '<path d="M18.5 14.5A8 8 0 0 1 8 4.2 8.5 8.5 0 1 0 18.5 14.5z"/>',
  warranty: '<path d="M12 3l7.5 3.2v5.3c0 5-3.5 8.4-7.5 9.5-4-1.1-7.5-4.5-7.5-9.5V6.2z"/><path d="M8.8 11.8l2.3 2.3 4.2-4.4"/>',
  returns: '<path d="M4.5 11a7.5 7.5 0 0 1 13-4.4l1.8 1.8"/><path d="M20 4.8v4h-4"/><path d="M19.5 13a7.5 7.5 0 0 1-13 4.4L4.7 15.6"/><path d="M4 19.2v-4h4"/>',
  gift: '<rect x="4.2" y="9.5" width="15.6" height="10.8"/><path d="M2.6 9.5h18.8v3.1H2.6z"/><path d="M12 9.5v10.8"/><path d="M12 9.5C12 6.7 10.2 4.6 8.3 5.4 6.6 6.1 7.4 9.5 12 9.5M12 9.5c0-2.8 1.8-4.9 3.7-4.1 1.7.7.9 4.1-3.7 4.1"/>'
};
const CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 12.5l4.5 4.5 9.5-11"/></svg>';
const CHEV = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M9 6l6 6-6 6"/></svg>';

/* benefit illustrations (consistent line-art set) */
const ILLU = {
  stress: '<svg viewBox="0 0 260 120" fill="none"><path d="M14 60q14-40 28 0t28 0q11-26 22 0t22 0q9-15 18 0t18 0q7-7 14 0t14 0h50" stroke="#C8A76A" stroke-width="2" stroke-linecap="round"/><circle cx="232" cy="60" r="4" fill="#9D7432"/></svg>',
  sleep: '<svg viewBox="0 0 260 120" fill="none"><path d="M148 30a32 32 0 1 0 0 60 40 40 0 0 1 0-60z" stroke="#9D7432" stroke-width="2"/><path d="M96 40l3 7 7 3-7 3-3 7-3-7-7-3 7-3z" fill="#C8A76A"/><path d="M180 64l2 5 5 2-5 2-2 5-2-5-5-2 5-2z" fill="#C8A76A"/></svg>',
  circulation: '<svg viewBox="0 0 260 120" fill="none"><path d="M130 26c34 0 56 14 56 34s-22 34-56 34-56-14-56-34 22-34 56-34z" stroke="#C8A76A" stroke-width="2"/><path d="M186 60l-7-6m7 6l-7 6M74 60l7-6m-7 6l7 6" stroke="#9D7432" stroke-width="2" stroke-linecap="round"/><circle cx="130" cy="60" r="6" fill="#9D7432"/></svg>',
  pain: '<svg viewBox="0 0 260 120" fill="none"><circle cx="130" cy="60" r="8" fill="#9D7432"/><circle cx="130" cy="60" r="20" stroke="#C8A76A" stroke-width="2"/><circle cx="130" cy="60" r="33" stroke="#C8A76A" stroke-width="1.6" opacity=".7"/><circle cx="130" cy="60" r="46" stroke="#C8A76A" stroke-width="1.4" opacity=".4"/></svg>',
  focus: '<svg viewBox="0 0 260 120" fill="none"><circle cx="130" cy="60" r="44" stroke="#C8A76A" stroke-width="1.4" opacity=".4"/><circle cx="130" cy="60" r="28" stroke="#C8A76A" stroke-width="1.8" opacity=".7"/><circle cx="130" cy="60" r="13" stroke="#9D7432" stroke-width="2"/><circle cx="130" cy="60" r="3.5" fill="#9D7432"/></svg>',
  mood: '<svg viewBox="0 0 260 120" fill="none"><path d="M104 40a22 22 0 1 0 0 40" stroke="#9D7432" stroke-width="2" stroke-linecap="round"/><path d="M156 40a22 22 0 1 1 0 40" stroke="#C8A76A" stroke-width="2" stroke-linecap="round"/><circle cx="130" cy="60" r="4" fill="#9D7432"/></svg>',
  energy: '<svg viewBox="0 0 260 120" fill="none"><circle cx="130" cy="60" r="9" fill="#9D7432"/><g stroke="#C8A76A" stroke-width="2" stroke-linecap="round"><path d="M130 30v-14M130 90v14M100 60H86M174 60h14M109 39l-10-10M151 39l10-10M109 81l-10 10M151 81l10 10"/></g></svg>'
};

/* compare-retail chart */
function chartSVG() {
  const retail = P.retail || 375;
  const direct = (VARIANTS.Gold && VARIANTS.Gold.price) || 188;
  const base = 214, top = 40, full = base - top, scale = full / retail;
  const tradH = retail * scale, alH = direct * scale;
  const tradProd = tradH * 0.18, alProd = alH * 0.45;
  const ty = base - tradH, ay = base - alH;
  return `<svg viewBox="0 0 420 268" fill="none" font-family="Neue Montreal,sans-serif">
    <line x1="40" y1="${base}" x2="392" y2="${base}" stroke="#E9E2D4" stroke-width="1.5"/>
    <!-- traditional -->
    <rect x="96" y="${ty}" width="92" height="${tradH - tradProd}" fill="#E8D8C4"/>
    <rect x="96" y="${base - tradProd}" width="92" height="${tradProd}" fill="#171411"/>
    <text x="142" y="${ty - 12}" text-anchor="middle" font-size="20" font-weight="500" fill="#171411">${money(retail)}</text>
    <text x="142" y="${base + 22}" text-anchor="middle" font-size="11.5" fill="#514A42">Traditional retail</text>
    <!-- auralign -->
    <rect x="248" y="${ay}" width="92" height="${alH - alProd}" fill="#C8A76A"/>
    <rect x="248" y="${base - alProd}" width="92" height="${alProd}" fill="#171411"/>
    <text x="294" y="${ay - 12}" text-anchor="middle" font-size="20" font-weight="500" fill="#9D7432">${money(direct)}</text>
    <text x="294" y="${base + 22}" text-anchor="middle" font-size="11.5" font-weight="500" fill="#171411">AURALIGN direct</text>
    <!-- legend -->
    <rect x="96" y="248" width="11" height="11" fill="#171411"/>
    <text x="114" y="257" font-size="10.5" fill="#6E665C">Materials &amp; craft</text>
    <rect x="232" y="248" width="11" height="11" fill="#E8D8C4"/>
    <text x="250" y="257" font-size="10.5" fill="#6E665C">Markup &amp; middlemen</text>
  </svg>`;
}

const TRUST = [
  { key: 'shipping', lbl: 'Free shipping' },
  { key: 'trial',    lbl: '90-day trial' },
  { key: 'warranty', lbl: 'Lifetime warranty' },
  { key: 'returns',  lbl: 'Free returns' }
];

/* explainer modal content */
const EXPLAIN = {
  shipping: { type: 'icon', icon: ICON.shipping, eyebrow: 'Shipping', title: 'Free, tracked shipping',
    body: `<p>Every order ships free with full tracking, dispatched within one working day.</p><ul><li>Carbon-neutral delivery on every parcel</li><li>Typical arrival: 3&ndash;6 business days</li><li>Express options offered at checkout</li></ul>` },
  trial: { type: 'icon', icon: ICON.trial, eyebrow: 'The promise', title: '90-day risk-free trial',
    body: `<p>Live with your AURALIGN piece for 90 days. Love how you look and feel and it&rsquo;s yours to keep &mdash; or send it back any time within the window for a full refund.</p><ul><li>100% satisfaction guaranteed</li><li>No restocking fees, ever</li><li>Return shipping is on us</li></ul>` },
  warranty: { type: 'icon', icon: ICON.warranty, eyebrow: 'Warranty', title: 'Covered for life',
    body: `<p>Each AURALIGN piece is backed by a lifetime warranty against manufacturing and finish defects.</p><ul><li>Plating, clasp and magnets all covered</li><li>Free repair or replacement under normal wear</li><li>Registered automatically with your order</li></ul>` },
  returns: { type: 'icon', icon: ICON.returns, eyebrow: 'Returns', title: 'Free, simple returns',
    body: `<p>Returns are free and effortless within the 90-day window &mdash; 100% satisfaction guaranteed, worn or not.</p><ul><li>Prepaid return label included</li><li>Refund within 3 business days of receipt</li><li>Free exchanges for another finish or piece</li></ul>` },
  retail: { type: 'chart', eyebrow: 'Honest pricing', title: 'Why comparable pieces cost ' + money(P.retail || 375),
    body: `<p>A comparable therapeutic vermeil piece &mdash; solid 925 silver, 18K vermeil and medical-grade magnets &mdash; lists near <b>${money(P.retail || 375)}</b> through traditional jewelers. Most of that price is structure, not the piece.</p>
      <p>Traditional retail stacks a wholesale margin, a roughly 2&times; store markup, retail overhead and returns on top of production. AURALIGN sells direct &mdash; removing the retailer and wholesale layers collapses 55&ndash;65% of the cost. Same materials, same craftsmanship, none of the middlemen.</p>
      <div class="infomodal__note"><b>Vermeil</b> is an FTC-regulated term (16 CFR &sect;23.4): a sterling-silver base plated with at least 2.5 microns of gold &mdash; 5&ndash;10&times; thicker than standard plating.</div>` }
};

const BUY_ACCORDION = P.accordion || [];

const BENEFITS = [
  { k: 'Down-regulate in minutes', t: 'Diminishes stress & anxiety', img: 'auralign-ring-showcase.webp?v=1776882120', illu: 'stress',
    body: `<p>Worn at the fingertip, the ring brings gentle, constant contact to a region Traditional Chinese Medicine associates with calming the mind. Small studies suggest acupressure can offer short-term relief from situational anxiety.</p><p>Many wearers describe the ring as a tactile anchor &mdash; a quiet cue to slow the breath and reset during demanding moments.</p>` },
  { k: 'Get the best sleep of your life', t: 'Promotes restful sleep', img: 'auralign-ring-showcase2343.webp?v=1776882351', illu: 'sleep',
    body: `<p>Fingertip points such as the Heart channel&rsquo;s endpoint are traditionally linked in TCM to a settled mind and easier sleep.</p><p>The ring becomes part of an unwinding ritual &mdash; a small, consistent sensation that signals the nervous system it&rsquo;s time to downshift. Wearers often pair it with a calmer pre-bed routine.</p>` },
  { k: 'More oxygen, less inflammation', t: 'Boosts blood circulation', img: 'auralign-ring-showcase8888.webp?v=1776882351', illu: 'circulation',
    body: `<p>Circulation is central to how the body feels warm and energized. We&rsquo;re candid here: controlled studies have not shown that static magnets meaningfully change blood flow.</p><p>What the ring offers is gentle stimulation and an invitation to mindful hand movement and awareness &mdash; a complementary practice, not a circulatory treatment.</p>` },
  { k: 'Activate self-healing mechanisms', t: 'Soothes pain at the source', img: 'auralign-ring-showcase11111.webp?v=1776882351', illu: 'pain',
    body: `<p>Static magnets have been used for pain relief for generations, and acupressure at the hands is a recognized self-care technique. Evidence from clinical trials is mixed.</p><p>Still, many wearers value the ring as a soothing point of focus &mdash; a portable, drug-free ritual they return to whenever discomfort calls for attention.</p>` },
  { k: 'Distraction fades, clarity enters', t: 'Sharpens focus & cognition', img: 'auralign-ring-showcase1244.webp?v=1776882121', illu: 'focus',
    body: `<p>A small, deliberate object on the finger can act as a mindfulness cue, drawing attention back to the present.</p><p>The ring makes no claim to enhance cognition directly &mdash; but users frequently report that its steady presence helps them re-center, interrupt distraction, and work with renewed clarity.</p>` },
  { k: 'Feel everything, respond better', t: 'Balances mood & emotions', img: 'auralign-ring-showcase232.webp?v=1776882452', illu: 'mood',
    body: `<p>In TCM, the Heart and Pericardium channels &mdash; both ending at the fingertips &mdash; are tied to emotional equilibrium.</p><p>The ring places gentle, ongoing contact at these endpoints. Many wearers describe it less as a cure and more as a companion: a grounding presence through the day.</p>` },
  { k: 'When pathways clear, vitality flows', t: 'Harmonizes your energy field', img: 'auralign-ring-showcase21323.webp?v=1776882452', illu: 'energy',
    body: `<p>&ldquo;Energy field&rdquo; reflects the TCM concept of <i>qi</i> flowing through meridians &mdash; a traditional model, not a measured physical force.</p><p>The ring is designed around that philosophy, sitting at meridian endpoints as a symbolic and tactile practice. For many, it&rsquo;s a meaningful daily ritual of balance and intention.</p>` }
];

const SCIENCE = (P.science && P.science.cards) || [];

const TESTIMONIALS = [
  { n: 'Marianne S.', a: 34, g: 'women/68', s: 5, t: 'A must-have daily essential', q: "Absolutely love this ring. It not only looks gorgeous but helps me feel more calm and balanced. I'm so grateful." },
  { n: 'Sarah C.', a: 41, g: 'women/44', s: 5, t: 'Exceeded my expectations', q: 'I was skeptical, but within a week my afternoon slump was gone. It looks like fine jewelry and does so much more.' },
  { n: 'Jo W.', a: 36, g: 'women/12', s: 5, t: 'Life-changing', q: 'I move it between fingers depending on how I feel. The flexibility is genius and it never leaves my hand.' },
  { n: 'Jacob R.', a: 33, g: 'men/32', s: 5, t: 'Better than my Oura ring', q: "Hands down the best money I've spent. Instead of just tracking my health, I'm actually doing something about it." },
  { n: 'Holly T.', a: 44, g: 'women/65', s: 5, t: 'A stunning piece of jewelry', q: 'Compliments everywhere I go. Nobody believes it has a wellness function until I explain — then they order one.' },
  { n: 'Anna D.', a: 47, g: 'women/30', s: 5, t: 'Like the volume turned down', q: 'My mind used to race constantly. Now there is a quiet I did not know I was missing. Worth every cent.' },
  { n: 'Jeremy A.', a: 27, g: 'men/45', s: 5, t: "It's transformed my sleep", q: 'I wear it on my ring finger overnight and fall asleep faster than I have in years. No charging, no app, just sleep.' },
  { n: 'Lina S.', a: 39, g: 'women/9', s: 5, t: 'So elegantly effective', q: 'Beautiful, comfortable, and I genuinely feel steadier wearing it. It has become part of who I am.' },
  { n: 'Kurt J.', a: 65, g: 'men/52', s: 5, t: 'Finally sleeping better', q: 'At my age I have tried everything. This simple ring did what supplements never could. My wife ordered one too.' },
  { n: 'Miriam T.', a: 59, g: 'women/76', s: 5, t: 'I feel like myself again', q: 'My energy is back, my hands feel warmer and lighter, and I just feel more like myself again. Truly remarkable.' }
];

/* Per-product FAQ phrases — the FAQ below is shared by all four PDPs, and it
   used to ship the Ring's wording everywhere (2026-08-16: the Bracelet FAQ
   answered magnetic-therapy with "your fingertip meridian endpoint"). Every
   product-specific phrase now resolves from P.key; wording per PRODUCTS.md
   mechanism framing. */
const PIECE_NAME = ({ ring: 'Ring', bracelet: 'Bracelet', necklace: 'Necklace', earrings: 'Earrings' })[P.key] || 'Ring';
const PIECE = PIECE_NAME.toLowerCase();
const POINT_AT = ({
  ring: 'at your fingertip meridian endpoints',
  bracelet: 'over the P6 (Neiguan) point on your inner wrist',
  necklace: 'at the heart-center area of your chest',
  earrings: 'at the auricular points of your ears'
})[P.key] || 'at your fingertip meridian endpoints';
const POINT_DOC = ({
  ring: 'Finger meridians are documented in Traditional Chinese Medicine',
  bracelet: 'The P6 (Neiguan) wrist point is one of the most studied points in acupressure',
  necklace: 'The heart-center area is a long-recognized focus in Traditional Chinese Medicine',
  earrings: 'Auricular points are documented across acupressure and TCM traditions'
})[P.key] || 'Finger meridians are documented in Traditional Chinese Medicine';

const FAQ = {
  Top: [
    { q: 'How does magnetic therapy actually work?', a: 'The N52 neodymium core holds a steady static field ' + POINT_AT + ', where acupressure has worked for centuries. Static magnet therapy is a long-established complementary practice. We offer the ' + PIECE + ' as a grounding wellness ritual — it is a wellness aid, not a medical device.' },
    { q: 'When will I feel results?', a: 'Many people describe the ' + PIECE + ' as a calming tactile anchor from the first wear. Any sleep, mood or focus benefits build gradually over 2–4 weeks of consistent daily wear, and vary from person to person.' },
    { q: 'Is there actual science behind this?', a: POINT_DOC + ', and small studies suggest acupressure can ease situational anxiety. We are candid where evidence is mixed — static magnet therapy is complementary, not clinically proven. We would rather be honest than overclaim.' },
    { q: 'How is this different from cheap magnetic bracelets?', a: 'Cheap pieces use weak magnets and plated base metal that tarnishes fast. The AURALIGN ' + PIECE_NAME + ' uses a 925 sterling silver base, FTC-grade 18K vermeil (2.5µm, 4-layer), and N52 — the highest commercial neodymium grade — positioned precisely at the mapped points.' },
    { q: 'Can I wear it all the time, even sleeping?', a: 'Yes. It is designed for continuous wear, and many customers wear it overnight as part of an unwinding ritual — just remove it before showering or swimming to protect the finish.' },
    { q: 'Do I need the app for the jewelry to work?', a: 'No. The jewelry works alone — wear it and the points do their job. AURALIGN Practice deepens it with guided sessions built around your piece.' },
    { q: 'What’s in AURALIGN Practice?', a: 'Guided calm and breath sessions, point-by-point pressure guides for each piece, and short courses — built to make your jewelry a daily practice.' },
    { q: 'What does it cost after the included year?', a: 'Your piece includes the first 12 months. After that, Practice is $144 a year — optional, and the jewelry keeps working either way.' }
  ],
  Craft: [
    { q: 'What materials are used?', a: 'A solid 925 sterling silver base, finished in 18K gold or rose-gold vermeil with patented 4-layer 2.5µm plating, and N52 neodymium magnets. Every piece passes a hypoallergenic and finish-durability check.' },
    { q: 'What does "vermeil" actually mean?', a: 'Vermeil is an FTC-regulated term (16 CFR §23.4): a sterling-silver base plated with at least 2.5 microns of gold — 5–10× thicker than standard plating, which is why it wears far better.' },
    { q: 'Will the gold finish wear off or tarnish?', a: 'Our 4-layer 2.5-micron vermeil is far more durable than standard plating. With normal care it resists fading and tarnishing for years, and the lifetime warranty covers finish defects.' },
    { q: 'Is the jewelry available in stores?', a: 'AURALIGN is sold exclusively online. Selling direct lets us keep the craftsmanship accessible without retail markups — and back every piece with our 90-day guarantee.' }
  ],
  Care: [
    { q: 'How do I clean and care for it?', a: 'Wipe with a soft cloth after wear. To deep-clean, soak 10–15 minutes in warm water with a drop of mild dish soap, brush gently, rinse and pat dry. Store in a soft pouch in a cool, dry place.' },
    { q: 'Can I wear it in the shower or while swimming?', a: 'It is water-resistant, but we recommend removing it before showering, swimming or exercise. Soaps, chlorine and salt water shorten the life of any plated finish.' },
    { q: 'Can I wear other jewelry alongside it?', a: 'Absolutely — it is designed to stack and layer. Many customers wear the full four-piece set as a complete meridian system.' },
    { q: 'What does the lifetime warranty cover?', a: 'It covers manufacturing and finish defects for the life of the product. If the plating or magnets ever fail under normal wear, we replace the piece free of charge.' }
  ],
  Safety: [
    { q: 'Will this interfere with a pacemaker or medical device?', a: 'If you use a pacemaker, defibrillator or insulin pump, please consult your doctor before wearing any magnetic product. The magnets are low-strength, but professional guidance comes first.' },
    { q: 'Is it hypoallergenic and safe for sensitive skin?', a: 'Yes. The 925 sterling silver base and vermeil finish are nickel-free and meet EN 1811 release limits for skin-contact jewelry.' },
    { q: 'Is it safe to wear during pregnancy?', a: 'Many customers wear it through pregnancy with no issues, but as with any wellness product we recommend checking with your healthcare provider first.' },
    { q: 'Will TSA or metal detectors be a problem?', a: 'No. It is a small piece of jewelry and behaves like any ring at airport security — no need to remove it.' }
  ]
};

const LIFESTYLE = [
  { tab: 'Stay aligned', t: 'A wellness habit with zero friction', b: 'No charging, no app, no daily routine to keep. You put it on once and your alignment practice runs quietly in the background, all day, every day.', img: 'auralign-ring-showcase_9.webp?v=1776882121' },
  { tab: 'Find your calm', t: 'A quieter nervous system', b: 'The steady contact at your meridian endpoint becomes a tactile cue to slow down. Customers describe it as someone gently turning the volume down.', img: 'auralign-ring-showcase_10.webp?v=1776882351' },
  { tab: 'Beyond tech', t: 'Wellness you wear, not a screen', b: 'Trackers tell you how you slept. The AURALIGN Ring is a ritual you actually perform — proactive support instead of one more dashboard to check.', img: 'auralign-ring-showcase8888.webp?v=1776882351' },
  { tab: 'Heal, naturally', t: 'Support what your body already knows', b: 'Frequency alignment, magnetotherapy and acupressure combine as a complementary daily practice — designed around your body\'s own rhythms.', img: 'auralign-archive-202.webp?v=1776882452' }
];

const SEAL_SVG = `<svg viewBox="0 0 132 132" fill="none">
  <circle cx="66" cy="66" r="62" stroke="currentColor" stroke-width="1"/>
  <circle cx="66" cy="66" r="52" stroke="currentColor" stroke-width="1.3" stroke-dasharray="1 5.5" stroke-linecap="round"/>
  <text x="66" y="36" text-anchor="middle" font-family="Neue Montreal,sans-serif" font-size="7.5" font-weight="500" letter-spacing="3.2" fill="currentColor">AURALIGN</text>
  <text x="66" y="79" text-anchor="middle" font-family="Neue Montreal,sans-serif" font-size="40" font-weight="500" letter-spacing="-1.5" fill="currentColor">90</text>
  <line x1="55" y1="89" x2="77" y2="89" stroke="currentColor" stroke-width="1"/>
  <text x="66" y="101" text-anchor="middle" font-family="Neue Montreal,sans-serif" font-size="7.5" font-weight="500" letter-spacing="2.8" fill="currentColor">DAY TRIAL</text>
  <path d="M15 66l3 -3 3 3-3 3z" fill="currentColor"/>
  <path d="M111 66l3 -3 3 3-3 3z" fill="currentColor"/>
</svg>`;

/* ---------------- STATE ---------------- */
/* state.cart holds the last-known Shopify cart response (from /cart.js).
   It is hydrated from the live Shopify cart, never from local in-memory pushes. */
const state = { size: SIZES[0], color: COLORS[0], galleryIndex: 0, cart: null };

/* ---------------- HELPERS ---------------- */
const $ = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => [...c.querySelectorAll(s)];

/* ---------------- OVERLAY REGISTRY ----------------
   One central owner for body scroll-lock, Esc, and focus-return across the PDP's
   own overlay layers. Only one overlay is active at a time: opening a new one
   closes the current first. This is the ONLY PDP code that writes
   document.body.style.overflow.

   W8: the private cart drawer ('cart') and mobile nav ('nav') were deleted when
   the PDP moved onto the global chrome, so 'modal' (size + info modals) is now
   the only registered layer. The GLOBAL cart drawer (assets/custom-cart.js) owns
   its own scroll-lock and focus and is deliberately NOT registered here — two
   owners writing body.style.overflow would fight. Add-to-Cart still closes an
   open modal first via Overlays.closeCurrent() (see notifyCartItemAdded), so the
   PDP releases its lock before the drawer takes its own. */
const Overlays = (() => {
  let current = null; let lastTrigger = null; let savedOverflow = '';
  function open(name, closeFn, trigger) {
    if (current && current.name !== name) current.close();
    if (!current) { savedOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
    current = { name, close: closeFn }; lastTrigger = trigger || document.activeElement;
  }
  function closed(name) {
    if (current && current.name === name) {
      current = null; document.body.style.overflow = savedOverflow;
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
      lastTrigger = null;
    }
  }
  function isOpen(name) { return !!current && current.name === name; }
  function closeCurrent() { if (current) current.close(); }
  return { open, closed, isOpen, closeCurrent };
})();

/* Resolve an image reference to a local theme-asset URL. Per-product images
   arrive pre-resolved from the template; shared engine images carry a bare
   filename looked up in window.ASSETS. */
const img = f => { if (!f) return ''; const k = String(f).split('?')[0]; return A[k] || f; };

/* True when a URL is a Shopify CDN path that serves ?width= transforms.
   Match the PATH, never the host: `asset_url` renders on the store's own
   domain (//auraligned.com/cdn/shop/t/6/assets/foo.webp?v=1), so a
   `cdn.shopify.com` host check matches NOTHING on the live site and silently
   disables every transform. The path covers both theme assets
   (/cdn/shop/t/<n>/assets/…) and uploads (/cdn/shop/files/…) on any host.
   data: URIs are excluded explicitly — a base64 payload could contain the
   path substring by chance, and appending a param would corrupt it. */
const canResize = u => !!u && !u.startsWith('data:') && u.includes('/cdn/shop/');

/* Append a ?width= param so the CDN returns an appropriately sized image.
   URLs that can't be transformed (data: URIs, genuinely external hosts) are
   returned unchanged. */
function imgW(f, w) {
  const resolved = img(f);
  if (!resolved || !w || !canResize(resolved)) return resolved;
  // Replace existing ?width= or append it
  if (/[?&]width=/.test(resolved)) {
    return resolved.replace(/([?&]width=)\d+/, '$1' + w);
  }
  return resolved + (resolved.includes('?') ? '&' : '?') + 'width=' + w;
}

/* Build a srcset candidate list from a ladder of widths. Rungs above the
   source's natural size are harmless — the CDN clamps to the natural size —
   so no per-file width knowledge is needed. Returns '' when the URL can't be
   transformed, so callers omit the attribute rather than emit a srcset of
   identical candidates. */
function imgSrcset(f, rungs) {
  if (!canResize(img(f))) return '';
  return rungs.map(w => imgW(f, w) + ' ' + w + 'w').join(', ');
}

function toast(msg) {
  const t = $('#toast');
  t.textContent = msg;
  t.classList.add('is-on');
  clearTimeout(t._t);
  t._t = setTimeout(() => t.classList.remove('is-on'), 2800);
}
function starRow(rating, size) {
  let h = '';
  for (let i = 1; i <= 5; i++) {
    const fill = rating >= i ? 1 : (rating > i - 1 ? rating - (i - 1) : 0);
    const id = 'st' + i + (size || '') + Math.random().toString(36).slice(2, 6);
    h += `<svg viewBox="0 0 24 24"><defs><linearGradient id="${id}"><stop offset="${fill * 100}%" stop-color="#C8A76A"/><stop offset="${fill * 100}%" stop-color="#E9E2D4"/></linearGradient></defs>
      <path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 18.4 6.1 21.5l1.2-6.5L2.5 10.4l6.6-.9z" fill="url(#${id})"/></svg>`;
  }
  return h;
}

/* Generate an inline SVG initials avatar as a data URI.
   Replaces all randomuser.me API calls — no external network requests. */
function avatarDataURI(name) {
  const initials = name.split(' ').map(s => s[0]).join('').slice(0, 2).toUpperCase();
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><circle cx='32' cy='32' r='32' fill='%23E8DCC4'/><text x='50%' y='54%' text-anchor='middle' font-family='system-ui,sans-serif' font-size='24' fill='%23171411'>${initials}</text></svg>`;
  return 'data:image/svg+xml;utf8,' + svg;
}

/* ---------------- iJewel3D ---------------- */
let viewerLoaded = false;
let viewerColor = null;
const NO_3D = /[?&]no3d/.test(location.search);
/* Latches when the viewer script fails to load or the model fails to mount, so
   the gallery degrades to photos-only and never re-attempts the 3D slide. */
let NO_3D_RUNTIME = false;
/* Eager-3D (2026-08-16, Viktor): the 360° model is the FIRST gallery slide —
   matching the live Replo PDP — instead of the last. Skipped on data-saver or
   slow connections, which keep the photos-first order. The slide shows the
   preloaded hero photo as a poster until the model's canvas actually paints,
   so first paint / LCP are unchanged. */
const EAGER_3D = !NO_3D && (() => {
  const c = navigator.connection || {};
  if (c.saveData) return false;
  return !c.effectiveType || c.effectiveType === '4g';
})();
/* The heavy viewer bundle must never load during the metrics-critical window:
   boot is allowed after the load event has gone idle (desktop) or on the first
   real interaction (mobile) — see scheduleViewerBoot(). Direct taps on the 360
   toggle/thumb also flip this on. */
let viewerBootAllowed = false;
/* The ijewel viewer bundle is heavy and used to block first paint. It is NOT
   loaded until the shopper actually reaches the 360° slide. loadViewerScript()
   injects it on demand (URL from window.PDP.viewerSrc) and caches the in-flight
   promise so concurrent triggers share one request. */
let viewerScriptPromise = null;
function loadViewerScript() {
  if (typeof ijewelViewer !== 'undefined') return Promise.resolve(true);
  if (viewerScriptPromise) return viewerScriptPromise;
  const src = (window.PDP && window.PDP.viewerSrc) || '';
  if (!src) return Promise.resolve(false);
  viewerScriptPromise = new Promise(resolve => {
    const s = document.createElement('script');
    s.src = src;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return viewerScriptPromise;
}
function mountViewer(color) {
  const container = $('#ijewel-viewer');
  if (!container || typeof ijewelViewer === 'undefined') return false;
  const modelId = IJEWEL_MODELS[color] || IJEWEL_MODELS.Gold;
  const wrap = container.closest('.ijewel-wrap');
  try {
    if (wrap) wrap.classList.remove('is-live');
    container.innerHTML = '';
    ijewelViewer.loadModelById(modelId, 'drive', container, {
      showLogo: false, showCard: false,
      ui: { controls: false, toolbar: false, help: false, fullscreen: false, resetCamera: false, autorotate: true }
    });
    viewerColor = color;
    /* One poll: strip viewer chrome AND fade the poster once a canvas exists.
       The canvas lives inside the viewer's shadow root. 120 × 250ms = 30s cap,
       matching the stall watchdog. */
    let tries = 0;
    const iv = setInterval(() => {
      const chromeDone = hideViewerChrome();
      const inner = container.querySelector('div');
      const canvas = container.querySelector('canvas') ||
        (inner && inner.shadowRoot && inner.shadowRoot.querySelector('canvas'));
      if (canvas && wrap) wrap.classList.add('is-live');
      if ((chromeDone && canvas) || ++tries > 120) clearInterval(iv);
    }, 250);
    return true;
  } catch (e) {
    container.innerHTML = '<div style="display:grid;place-items:center;height:100%;color:#8a8177;font-size:13px">3D preview unavailable offline</div>';
    return false;
  }
}
function initViewer() {
  if (viewerLoaded || NO_3D || NO_3D_RUNTIME) return;
  loadViewerScript().then(ok => {
    if (ok && mountViewer(state.color)) {
      viewerLoaded = true;
      // Model stall watchdog: if no canvas paints within 30s, fall back to photos.
      // The rendered canvas lives inside the viewer's shadow root (see
      // hideViewerChrome), so a light-DOM lookup alone can't see it.
      // 30s, not less: the model chain is ~17 MB across five hosts (11.5 MB .glb
      // alone) — a 12s cutoff was tearing the 360° UI out mid-download on
      // ordinary cellular connections that would have finished.
      setTimeout(() => {
        const host = $('#ijewel-viewer');
        if (!viewerLoaded || !host) return;
        const inner = host.querySelector('div');
        const hasCanvas = host.querySelector('canvas') ||
          (inner && inner.shadowRoot && inner.shadowRoot.querySelector('canvas'));
        if (!hasCanvas) disable3D();
      }, 30000);
      return;
    }
    disable3D();
  });
}
/* Viewer script failed to load, or the model failed to mount — strip every 3D
   affordance and fall back to a photos-only gallery. Guarded so its teardown
   runs once; buildGallery() then rebuilds with the 3D slide gone, so
   updateGalleryUI() can never re-enter initViewer(). */
function disable3D() {
  if (NO_3D_RUNTIME) return;
  NO_3D_RUNTIME = true;
  const t = $('.thumb--3d'); if (t) t.remove();
  const modeBox = $('#galleryMode'); if (modeBox) modeBox.style.display = 'none';
  const slide3d = $('.gallery__slide--3d'); if (slide3d) slide3d.remove();
  buildGallery();
}
/* Re-point the 3D viewer when the finish changes — mirrors the live
   auraligned.com behaviour (each finish is its own iJewel model). No-ops until
   the viewer has actually been loaded on demand. */
function swapViewer(color) {
  if (NO_3D || NO_3D_RUNTIME || !viewerLoaded || viewerColor === color) return;
  mountViewer(color);
}
function hideViewerChrome() {
  const host = document.querySelector('#ijewel-viewer div');
  if (!host || !host.shadowRoot) return false;
  if (host.shadowRoot.getElementById('al-viewer-clean')) return true;
  const s = document.createElement('style');
  s.id = 'al-viewer-clean';
  s.textContent =
    '#webgi-wrapper > .custom-scroll{display:none!important}' +
    /* Suppress residual iJewel toolbar/chrome (gear/rotate/flip/fullscreen) that
       can survive the ui:{toolbar:false,controls:false} mount options. Blanket
       is scoped to the shadow root; canvas rule is kept last so it wins. */
    '[class*="toolbar"],[class*="controls"],[class*="menu"]{display:none!important}' +
    '#webgi-canvas-container canvas{cursor:grab;width:100%!important;height:100%!important}';
  host.shadowRoot.appendChild(s);
  return true;
}

/* ---------------- GALLERY ---------------- */
/* Slides render at ~656px in the desktop grid column and full-bleed on mobile;
   thumbs are a fixed 78px rail. */
const GALLERY_RUNGS = [400, 600, 900, 1200, 1800];
const GALLERY_SIZES = '(min-width: 990px) 660px, 100vw';
const THUMB_RUNGS   = [200, 400];

function buildGallery() {
  const vp = $('#galleryViewport'), thumbs = $('#galleryThumbs');
  /* Drop the server hero slide (data-kind="hero-photo") and any prior JS photo
     slides; keep the 3D slide node so we can relocate it to the end. */
  $$('.gallery__slide:not(.gallery__slide--3d)', vp).forEach(n => n.remove());
  const slide3d = $('.gallery__slide--3d', vp);
  const has3D = !NO_3D && !NO_3D_RUNTIME && !!slide3d;
  /* Eager-3D ordering: the 360° slide is index 0 and photos follow at 1..N.
     On saveData/slow links (or after a viewer failure) photos stay first and
     the 3D slide sits at the end, as before. */
  const eager = has3D && EAGER_3D;
  const photoOffset = eager ? 1 : 0;
  const modeBox = $('#galleryMode');
  thumbs.innerHTML = '';
  /* Keep the 3D poster on the current finish so the slide is never blank while
     the model streams (and never re-set an identical URL — double-fetch trap). */
  if (has3D) {
    const poster = $('#ijewelPoster');
    const pf = (IMAGES[state.color] || [])[0];
    if (poster && pf) {
      const psrc = imgW(pf, 1400);
      if (poster.getAttribute('src') !== psrc) {
        const pss = imgSrcset(pf, GALLERY_RUNGS);
        poster.src = psrc;
        if (pss) poster.srcset = pss;
      }
    }
  }
  const imgs = IMAGES[state.color] || [];
  imgs.forEach((f, i) => {
    const slide = document.createElement('div');
    slide.className = 'gallery__slide';
    slide.dataset.kind = 'photo';
    const ss = imgSrcset(f, GALLERY_RUNGS);
    slide.innerHTML = `<img src="${imgW(f, 1400)}"${ss ? ` srcset="${ss}" sizes="${GALLERY_SIZES}"` : ''} alt="${(P.title || 'AURALIGN')} in ${state.color}" width="1400" height="1400" loading="${i < 2 ? 'eager' : 'lazy'}" />`;
    /* eager: 3D slide is already the first child — append photos after it.
       photos-first: insert photos before the 3D slide (which stays last). */
    if (eager || !slide3d) vp.appendChild(slide); else vp.insertBefore(slide, slide3d);
    const th = document.createElement('button');
    /* type + aria-label: these buttons carried no accessible name at all — the
       only child is an alt="" img — so screen readers announced four unlabelled
       buttons (Lighthouse `button-name`, 2026-08-09 audit F16). */
    th.type = 'button';
    th.className = 'thumb';
    th.setAttribute('aria-label', `View image ${i + 1} of ${imgs.length}`);
    th.dataset.idx = String(i + photoOffset);
    const ts = imgSrcset(f, THUMB_RUNGS);
    th.innerHTML = `<img src="${imgW(f, 200)}"${ts ? ` srcset="${ts}" sizes="78px"` : ''} alt="" loading="lazy" decoding="async" />`;
    thumbs.appendChild(th);
  });
  if (has3D) {
    if (eager) vp.prepend(slide3d); else vp.appendChild(slide3d);
    const t3d = document.createElement('button');
    t3d.type = 'button';
    t3d.className = 'thumb thumb--3d';
    t3d.setAttribute('aria-label', 'View the 360° model');
    t3d.innerHTML = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M12 2.5l9 5v9l-9 5-9-5v-9z"/><path d="M3 7.5l9 5 9-5M12 12.5v9.5"/></svg>360°';
    t3d.dataset.idx = eager ? '0' : String(imgs.length);
    if (eager) thumbs.prepend(t3d); else thumbs.appendChild(t3d);
    if (modeBox) modeBox.style.display = '';
  } else {
    if (slide3d) slide3d.remove();
    if (modeBox) modeBox.style.display = 'none';
  }
  $$('.thumb', thumbs).forEach(th => th.addEventListener('click', () => scrollToSlide(+th.dataset.idx)));
  scrollToSlide(0, true);
  updateGalleryUI();
}
function slideCount() { return $$('.gallery__slide').length; }
/* Index of the 3D slide in DOM order, or -1 when there is no 3D slide
   (photos-only fallback, or NO_3D). Photos occupy 0..N-1; the 3D slide is last. */
function IDX3D() { return $$('.gallery__slide').findIndex(s => s.classList.contains('gallery__slide--3d')); }
/* First photo slide index — 1 when the 3D slide leads (eager order), else 0. */
function photoStartIdx() { return IDX3D() === 0 ? 1 : 0; }
function scrollToSlide(i, instant) {
  const vp = $('#galleryViewport');
  i = Math.max(0, Math.min(i, slideCount() - 1));
  state.galleryIndex = i;
  vp.scrollTo({ left: vp.clientWidth * i, behavior: instant ? 'auto' : 'smooth' });
  updateGalleryUI();
}
function updateGalleryUI() {
  const i = state.galleryIndex;
  const i3d = IDX3D();
  const on3d = i3d !== -1 && i === i3d;
  $('#galleryBadge').textContent = `${i + 1} / ${slideCount()}`;
  $$('.thumb').forEach(t => t.classList.toggle('is-active', +t.dataset.idx === i));
  $$('#galleryMode button').forEach(b => {
    const active = (b.dataset.mode === '3d') === on3d;
    b.classList.toggle('is-active', active);
    b.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  /* Boot the viewer when the shopper is on the 3D slide — but never during the
     metrics-critical first-paint window (viewerBootAllowed flips on in
     scheduleViewerBoot, on interaction or post-load idle). */
  if (on3d && viewerBootAllowed) initViewer();
}
function initGalleryControls() {
  const vp = $('#galleryViewport');
  let raf;
  vp.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const idx = Math.round(vp.scrollLeft / vp.clientWidth);
      if (idx !== state.galleryIndex) { state.galleryIndex = idx; updateGalleryUI(); }
    });
  });
  $('#galleryPrev').addEventListener('click', () => {
    const n = slideCount();
    scrollToSlide((state.galleryIndex - 1 + n) % n);
  });
  $('#galleryNext').addEventListener('click', () => {
    const n = slideCount();
    scrollToSlide((state.galleryIndex + 1) % n);
  });
  $$('#galleryMode button').forEach(b => b.addEventListener('click', () =>
    scrollToSlide(b.dataset.mode === '3d' ? IDX3D() : photoStartIdx())));
}

/* ---------------- VARIANTS ---------------- */
function buildVariants() {
  const colorBox = $('#colorChoices');
  colorBox.innerHTML = COLORS.map(c => `
    <button class="finish finish--${SWATCH[c]}${c === state.color ? ' is-active' : ''}" data-color="${c}" aria-label="${FINISH_LABEL[c]}">
      <span class="finish__sw" style="background-image:url('${imgW(PLAIN[c], 400)}')"></span>
      <span class="finish__name">${FINISH_LABEL[c]}</span>
      <span class="finish__price">${money(VARIANTS[c].price)}</span>
    </button>`).join('');
  $('#colorChosen').textContent = FINISH_LABEL[state.color];
  $$('button', colorBox).forEach(b => b.addEventListener('click', () => {
    if (state.color === b.dataset.color) return;
    state.color = b.dataset.color;
    $('#colorChosen').textContent = FINISH_LABEL[state.color];
    $$('button', colorBox).forEach(x => x.classList.toggle('is-active', x === b));
    buildGallery();
    buildUpsell();
    updatePrice();
    swapViewer(state.color);
    // Propagate finish/color change to the sticky ATC display
    stickyRefresh();
  }));

  /* Necklace & Earrings have no size option — hide the whole control. */
  if (!HAS_SIZE) {
    const sizeOpt = $('#sizeOpt');
    if (sizeOpt) sizeOpt.style.display = 'none';
    return;
  }
  const sizeBox = $('#sizeChoices');
  $('#sizeChosen').textContent = shortSize(state.size);
  sizeBox.innerHTML = SIZES.map(s => `<button class="seg${s === state.size ? ' is-active' : ''}" data-size="${s}">${shortSize(s)}</button>`).join('');
  $$('button', sizeBox).forEach(b => b.addEventListener('click', () => {
    state.size = b.dataset.size;
    $('#sizeChosen').textContent = shortSize(state.size);
    $$('button', sizeBox).forEach(x => x.classList.toggle('is-active', x === b));
  }));
}
function updatePrice() {
  const v = VARIANTS[state.color];
  $('#priceNow').textContent = money(v.price);
  $('#priceWas').textContent = money(v.compare);
  $('#atcPrice').textContent = money(v.price);
  $('#finalPrice').textContent = money(v.price);
  $('#stickyPrice').textContent = money(v.price);
}

/* ---------------- TRUST PILLS / BULLETS ---------------- */
function buildTrust() {
  $('#trustRow').innerHTML = TRUST.map(t => `
    <li><button data-info="${t.key}">
      <span class="tpills__ico"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">${ICON[t.key]}</svg></span>
      <span class="tpills__lbl">${t.lbl}</span>
      <span class="tpills__chev">${CHEV}</span>
    </button></li>`).join('');
  $$('#trustRow button').forEach(b => b.addEventListener('click', () => openExplain(b.dataset.info)));
}

/* ---------------- PROOF BADGE / TABS / TICKER ---------------- */
function buildProofBadge() {
  /* Use inline SVG initials avatars — no external network calls to randomuser.me */
  const avs = TESTIMONIALS.slice(0, 3).map(t =>
    `<span style="background-image:url('${avatarDataURI(t.n)}')"></span>`).join('');
  $('#proofBadge').innerHTML = `
    <div class="proofbadge__top">${LAUREL}<span class="proofbadge__title">Loved &amp; worn daily</span><span style="display:inline-flex;transform:scaleX(-1)">${LAUREL}</span></div>
    <p><b>60,000+ people</b> wear AURALIGN as part of their everyday ritual.</p>
    <div class="proofbadge__foot"><span class="proofbadge__avatars">${avs}</span><button class="proofbadge__link" id="proofLink">Read their stories →</button></div>`;
  $('#proofLink').addEventListener('click', () => { const rv = document.getElementById('auralign-reviews'); if (rv) rv.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
  /* The buy box's #valrowLink needs no JS: it is a real anchor to #practice —
     html's smooth scroll-behavior (with the global reduced-motion override)
     plus .pdpprac's scroll-margin-top handle motion, offset, hash and focus. */
}
function buildBxTabs() {
  // TODO: ARIA tabs pattern (role=tablist/tab/tabpanel)
  const el = $('#bxTabs');
  el.innerHTML = `<div class="bxtabs__bar">${BXTABS.map((t, i) =>
    `<button class="bxtab${i === 0 ? ' is-active' : ''}" data-i="${i}">${t.tab}</button>`).join('')}</div>
    <div class="bxtabs__panel" id="bxPanel"></div>`;
  const panel = $('#bxPanel');
  const render = i => {
    panel.innerHTML = BXTABS[i].rows.map(r => `
      <div class="bxrow">
        <span class="bxrow__ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">${BX_ICON[r.ic]}</svg></span>
        <p>${r.t}</p>
      </div>`).join('');
  };
  render(0);
  $$('.bxtab', el).forEach(tab => tab.addEventListener('click', () => {
    $$('.bxtab', el).forEach(t => t.classList.toggle('is-active', t === tab));
    render(+tab.dataset.i);
  }));
}
function buildTicker() {
  const t = TICKER.map(x => `<span>${x}</span>`).join('');
  $('#tickerTrack').innerHTML = t + t + t;
}
function rotateHint() {
  const hint = $('.ijewel-hint');
  if (!hint) return;
  const states = [
    { i: '<path d="M3 12a9 9 0 0 1 9-9M21 12a9 9 0 0 1-9 9"/><path d="M3 12l2.4-2M21 12l-2.4 2"/>', t: 'Drag to rotate' },
    { i: '<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15 15l5.5 5.5M8 10.5h5M10.5 8v5"/>', t: 'Pinch to zoom' }
  ];
  const paint = n => {
    const s = states[n % 2];
    hint.innerHTML = `<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.6">${s.i}</svg>${s.t}`;
  };
  paint(0);
  /* "Pinch to zoom" is touch-only guidance — never cycle it on desktop
     (≥1024px), where there is no pinch gesture. Static "Drag to rotate" stays. */
  if (!window.matchMedia('(max-width: 1023px)').matches) return;
  let n = 0;
  setInterval(() => { n++; paint(n); }, 3400);
}

/* ---------------- ACCORDION ---------------- */
function buildAccordion(el, items) {
  el.innerHTML = items.map(it => `
    <div class="acc-item">
      <button class="acc-head" aria-expanded="false">${it.t}<span class="acc-ico"></span></button>
      <div class="acc-body"><div class="acc-body__in">${it.h}</div></div>
    </div>`).join('');
  $$('.acc-head', el).forEach(head => head.addEventListener('click', () => {
    const item = head.parentElement, body = $('.acc-body', item);
    const open = item.classList.contains('is-open');
    $$('.acc-item', el).forEach(i => {
      i.classList.remove('is-open');
      $('.acc-body', i).style.maxHeight = null;
      $('.acc-head', i).setAttribute('aria-expanded', 'false');
    });
    if (!open) {
      item.classList.add('is-open');
      body.style.maxHeight = body.scrollHeight + 'px';
      head.setAttribute('aria-expanded', 'true');
    }
  }));
}

/* ---------------- UPSELL ---------------- */
function buildUpsell() {
  $('#upsellList').innerHTML = UPSELL.map((u, i) => {
    const v = u.variants[state.color];
    return `
    <div class="ucard" data-up="${i}">
      <img src="${imgW(u.cardImg[state.color], 200)}" alt="${u.name}" loading="lazy" decoding="async" />
      <div class="ucard__info"><h4>${u.name}</h4><p>${u.meridian} &middot; ${FINISH_LABEL[state.color]}</p></div>
      <span class="ucard__price"><s>${money(v.compare)}</s>${money(v.price)}</span>
      <button class="ucard__add" aria-label="Add ${u.name}">+</button>
    </div>`;
  }).join('');
  $$('.ucard__add').forEach(btn => btn.addEventListener('click', () => {
    const u = UPSELL[+btn.closest('.ucard').dataset.up];
    /* Immediate press feedback (2026-08-16): the add is async — without this
       the button read as dead until the drawer opened. Mirrors the cart
       drawer's own bundle-card pattern (disabled + ellipsis). */
    if (btn.disabled) return;
    const prevLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    const restore = () => { btn.disabled = false; btn.textContent = prevLabel; };
    const settle = p => p.then(() => { restore(); }, () => { restore(); });
    /* Upsell ATC: resolve variant ID from window.PDP.upsellVariantIds keyed by
       "handle|color" (injected by the sibling product-template agent).
       Fallback: fetch /products/<handle>.js at add time to look up the variant ID
       dynamically. We use the upsellVariantIds map when available because it's
       synchronous and avoids an extra network round-trip per add.
       NOTE: upsell products are always single-option (finish only), so this
       lookup by state.color is correct and does NOT need the getVariantId()
       multi-option fix — it uses a separate upsellVariantIds map, not variantIds. */
    const upsellIds = (window.PDP && window.PDP.upsellVariantIds) || {};
    const upsellKey = u.handle + '|' + state.color;
    const variantId = upsellIds[upsellKey];
    /* FIX 1: after a successful upsell add, open the cart drawer so the
       newly-added item is immediately visible. Both branches notify the global
       drawer after the cart refreshes — identical behaviour to addRingToCart(). */
    if (variantId) {
      settle(addToShopifyCart(variantId, 1, u.name.replace('AURALIGN ', '') + ' added to cart'));
    } else {
      /* Fallback: look up the variant by handle + selected option value */
      settle(fetch('/products/' + u.handle + '.js')
        .then(r => r.json())
        .then(product => {
          const colorOption = state.color;
          const variant = product.variants.find(v =>
            v.options && v.options.some(o => o === colorOption)
          );
          if (!variant) { toast('Sorry, this variant is unavailable'); return; }
          return addToShopifyCart(variant.id, 1, u.name.replace('AURALIGN ', '') + ' added to cart');
        })
        .catch(() => toast('Could not add item — please try again')));
    }
  }));
}

/* ---------------- BENEFITS ---------------- */
function buildBenefits() {
  const rail = $('#benefitRail');
  rail.innerHTML = BENEFITS.map((b, i) => `
    <button class="bcard" data-benefit="${i}">
      <img src="${imgW(b.img, 700)}" alt="${b.t}" loading="lazy" decoding="async" />
      <div class="bcard__veil"></div>
      <div class="bcard__txt">
        <p class="bcard__kick">${b.k}</p>
        <h3>${b.t}</h3>
        <span class="bcard__more">Learn more</span>
      </div>
    </button>`).join('');
  $$('.bcard', rail).forEach(c => c.addEventListener('click', () => openBenefit(+c.dataset.benefit)));
  setupRail(rail, '#benefitDots', '#benefitPrev', '#benefitNext');
}

/* ---------------- SCIENCE ---------------- */
function buildScience() {
  const box = $('#scienceCards');
  /* Necklace & Earrings present the science as a single paragraph — no card carousel. */
  if (!SCIENCE.length) { box.style.display = 'none'; return; }
  box.innerHTML = SCIENCE.map((s, i) => `
    <div class="scard${i === 0 ? ' is-open' : ''}">
      <button class="scard__head">
        <span class="scard__n">0${i + 1}</span>
        <strong>${s.t}</strong>
        <svg class="scard__chev" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 9l6 6 6-6"/></svg>
      </button>
      <div class="scard__body"><p>${s.b}</p></div>
    </div>`).join('');
  const cards = $$('.scard', box);
  cards.forEach(card => {
    const body = $('.scard__body', card);
    if (card.classList.contains('is-open')) body.style.maxHeight = body.scrollHeight + 'px';
    $('.scard__head', card).addEventListener('click', () => {
      const open = card.classList.contains('is-open');
      cards.forEach(c => { c.classList.remove('is-open'); $('.scard__body', c).style.maxHeight = null; });
      if (!open) { card.classList.add('is-open'); body.style.maxHeight = body.scrollHeight + 'px'; }
    });
  });
}

/* ---------------- TESTIMONIALS ----------------
   Removed: the hardcoded testimonials carousel is superseded by the
   custom-reviews module (#auralign-reviews). TESTIMONIALS is retained only
   for the proof-badge avatar initials. */

/* ---------------- RAIL ---------------- */
function setupRail(rail, dotsSel, prevSel, nextSel) {
  const cards = [...rail.children], dotsBox = $(dotsSel);
  dotsBox.innerHTML = cards.map((_, i) => `<button data-i="${i}" aria-label="Go to ${i + 1}"><i></i></button>`).join('');
  const dots = $$('button', dotsBox);
  const step = () => (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth);
  const sync = () => {
    const c = Math.max(0, Math.min(Math.round(rail.scrollLeft / step()), cards.length - 1));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === c));
  };
  let raf;
  rail.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); });
  dots.forEach(d => d.addEventListener('click', () => rail.scrollTo({ left: step() * +d.dataset.i, behavior: 'smooth' })));
  $(prevSel).addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
  $(nextSel).addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
  sync();
}

/* ---------------- FAQ ---------------- */
function buildFAQ() {
  // TODO: ARIA tabs pattern (role=tablist/tab/tabpanel)
  const tabsBox = $('#faqTabs'), cats = Object.keys(FAQ);
  tabsBox.innerHTML = cats.map((c, i) => `<button class="faq__tab${i === 0 ? ' is-active' : ''}" data-cat="${c}">${c}</button>`).join('');
  const render = cat => buildAccordion($('#faqList'), FAQ[cat].map(f => ({ t: f.q, h: `<p>${f.a}</p>` })));
  render(cats[0]);
  $$('.faq__tab', tabsBox).forEach(tab => tab.addEventListener('click', () => {
    $$('.faq__tab', tabsBox).forEach(t => t.classList.toggle('is-active', t === tab));
    render(tab.dataset.cat);
  }));
}

/* ---------------- LIFESTYLE ---------------- */
function buildLifestyle() {
  // TODO: ARIA tabs pattern (role=tablist/tab/tabpanel)
  const tabsBox = $('#lifeTabs');
  tabsBox.innerHTML = LIFESTYLE.map((l, i) => `<button class="lifestyle__tab${i === 0 ? ' is-active' : ''}" data-i="${i}">${l.tab}</button>`).join('');
  const panel = $('#lifePanel');
  const render = i => {
    const l = LIFESTYLE[i];
    panel.innerHTML = `
      <img src="${imgW(l.img, 1100)}" alt="${l.t}" loading="lazy" decoding="async" />
      <div class="lpanel__copy"><span class="lpanel__num">0${i + 1} — ${l.tab}</span><h3>${l.t}</h3><p>${l.b}</p></div>`;
  };
  render(0);
  $$('.lifestyle__tab', tabsBox).forEach(tab => tab.addEventListener('click', () => {
    $$('.lifestyle__tab', tabsBox).forEach(t => t.classList.toggle('is-active', t === tab));
    render(+tab.dataset.i);
  }));
}

/* ---------------- CART — real Shopify cart API ---------------- */

/* Resolve the correct Shopify variant ID from the current UI state.
   The variantIds map is keyed by variant.title (Shopify's auto-generated
   "option1 / option2 / ..." string) so it works for all products:
     - Single-option (necklace, earrings): title = "Gold" → ids["Gold"]
     - Two-option (ring, bracelet):        title = "Men's (Adjustable) / Gold" → ids["Men's (Adjustable) / Gold"]
   optionNames carries the Shopify option names in order so we can reconstruct
   the title key from the current state values. Returns null if any option has
   not yet been selected, so callers can bail before firing a broken request. */
function getVariantId() {
  const ids = (window.PDP && window.PDP.variantIds) || {};
  const opts = (window.PDP && window.PDP.optionNames) || [];

  if (opts.length === 0) {
    // Legacy / no optionNames present: fall back to color-only lookup
    return ids[state.color] || ids[state.size] || null;
  }

  const parts = opts.map(name => {
    const lower = name.toLowerCase();
    if (lower.includes('size')) return state.size || null;
    if (lower.includes('color') || lower.includes('colour') || lower.includes('finish')) return state.color || null;
    // Generic fallback: look for a state key matching the option name
    return state[lower] || null;
  });

  // If any option value is missing, return null so the caller can show a warning
  if (parts.some(p => !p)) return null;

  const key = parts.join(' / ');
  return ids[key] || null;
}

/* Low-level: POST to /cart/add.js, then refresh the cart drawer from /cart.js.
   toastMsg is shown on success; pass null to suppress. */
function addToShopifyCart(variantId, quantity, toastMsg) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
  })
    .then(r => {
      if (!r.ok) return r.json().then(d => Promise.reject(d));
      return r.json();
    })
    .then(() => {
      /* Open the drawer as soon as the add itself succeeds (2026-08-16): the
         old flow waited for the PDP's own /cart.js hydration AND the drawer's
         section-render before anything visible happened — measured ~4.7s of
         apparent dead click. The drawer opens instantly now and refreshes its
         own contents; fetchCart() hydrates the PDP bundle UI in parallel. */
      notifyCartItemAdded();
      if (toastMsg) toast(toastMsg);
      return fetchCart();
    })
    .catch(err => {
      const msg = (err && err.description) || 'Could not add to cart — please try again';
      toast(msg);
      return Promise.reject(err);
    });
}

/* Fetch the live Shopify cart and cache it on state.cart, then re-render. */
function fetchCart() {
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(cart => {
      state.cart = cart;
      /* W8: the drawer's own render is gone with the private drawer — the global
         drawer refreshes itself off cart:item-added. What still lives on this page
         is the PDP-body bundle UI (the "Complete the set" upsell ladder), so keep
         hydrating that from every cart response. */
      refreshBundleUI();
      /* FIX 4: keep the sticky bar label in sync after every cart hydration */
      stickyRefresh();
      /* Cross-tab sync: notify other tabs that the cart changed. custom-cross-
         tab.js listens for cart:updated and broadcasts to other tabs via
         BroadcastChannel. We also listen below for incoming broadcasts. */
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return cart;
    });
}

/* Listen for cross-tab cart updates. The custom-cross-tab.js relay dispatches
   cart:updated with detail.__fromBroadcast=true when ANOTHER tab mutates the
   cart. Refetch so this PDP's cart drawer reflects reality. */
document.addEventListener('cart:updated', function (ev) {
  if (ev && ev.detail && ev.detail.__fromBroadcast) {
    fetchCart();
  }
});

/* Add the current product to the Shopify cart.
   Resolves variantId via getVariantId() which composes the correct
   variant.title key from current state for both single- and multi-option
   products. Falls back gracefully if the map is missing or incomplete. */
function addRingToCart(btn) {
  /* Null guard — btn is optional (called from finalAtc without an argument) */
  if (btn) {
    const lbl = $('.atc__label', btn);
    if (!lbl) return;
    btn.disabled = true;
  }

  const variantId = getVariantId();

  if (!variantId) {
    toast(HAS_SIZE ? 'Please select a size and finish' : 'Variant unavailable — please refresh and try again');
    if (btn) btn.disabled = false;
    return;
  }

  addToShopifyCart(variantId, 1, null)
    .then(() => {
      if (btn) {
        const lbl = $('.atc__label', btn);
        if (lbl) {
          const orig = lbl.textContent;
          btn.classList.add('is-added');
          lbl.textContent = 'Added to cart ✓';
          setTimeout(() => {
            btn.classList.remove('is-added');
            lbl.textContent = orig;
            btn.disabled = false;
          }, 1600);
        } else {
          btn.disabled = false;
        }
      }
      /* notifyCartItemAdded() now fires inside addToShopifyCart, right after
         the add succeeds — before the PDP's own cart hydration. */
    })
    .catch(() => {
      if (btn) btn.disabled = false;
    });
}

/* Total quantity of AURALIGN pieces in cart — sums quantity across line items
   whose handle matches one of the four AURALIGN products. This is the unit
   the Shopify automatic discounts trigger on. */
function cartAuralignQty() {
  if (!state.cart || !state.cart.items) return 0;
  const auralignHandles = new Set(PRODUCTS.map(p => p.handle));
  let n = 0;
  state.cart.items.forEach(it => { if (auralignHandles.has(it.handle)) n += it.quantity; });
  return n;
}

/* Bundle ladder as a PROGRESS BAR (2026-08-16, Viktor — replaces the four tier
   boxes). Same visual system as the cart drawer's bundle meter: 5px rounded
   track, ink→champagne fill, tier stops along the track. Fill = pieces in cart
   out of 5; each stop lights up as its tier unlocks. */
function updateUpsellLadder(qty) {
  const el = $('#upsellLadder');
  if (!el) return;
  const capped = Math.min(qty, 5);
  const fillPct = Math.round((capped / 5) * 100);
  const stops = BUNDLE_TIERS.map(t => {
    const pos = (t.min / 5) * 100;
    const active = qty >= t.min;
    const current = active && tierPct(qty) === t.pct;
    return `<span class="upladder__stop${active ? ' is-active' : ''}${current ? ' is-current' : ''}" style="left:${pos}%">
      <span class="upladder__dot"></span>
      <span class="upladder__pct">&minus;${t.pct}%</span>
      <span class="upladder__qty">${t.min} pcs</span>
    </span>`;
  }).join('');
  el.innerHTML = `
    <div class="upladder" role="img" aria-label="Bundle discount ladder: ${capped} of 5 pieces in your cart${tierPct(qty) ? ', ' + tierPct(qty) + '% off unlocked' : ''}">
      <div class="upladder__track"><div class="upladder__fill" style="width:${fillPct}%"></div></div>
      <div class="upladder__stops">${stops}</div>
    </div>`;
}

function refreshBundleUI() {
  /* W8: the cart-totals rows and the tier-up celebration both lived inside the
     private cart drawer and went with it — the global drawer renders its own
     totals (cart-drawer__bundle) and fires its own bundle_tier_unlocked. What
     still lives on the PDP body is the "Complete the set" upsell ladder, so this
     keeps it tracking the live cart on every hydration. */
  updateUpsellLadder(cartAuralignQty());
}

/* ---------------- GLOBAL CART DRAWER ----------------
   W8: the PDP no longer ships a private cart drawer. The drawer is owned by the
   layout (sections/custom-cart-drawer.liquid + assets/custom-cart.js) and renders
   on every page. It manages its own open/close state, scroll-lock and focus, so it
   is deliberately NOT registered in the Overlays registry above — we talk to it
   only through the two document events it listens for (assets/custom-cart.js):

     cart:item-added -> refreshDrawer().then(openDrawer)   refresh AND open
     cart:open       -> openDrawer()                       open only

   This is the same contract snippets/custom-bundle-core.liquid submit() uses.
   Analytics (cart_open / bundle_tier_unlocked / checkout_started) are emitted by
   custom-cart.js itself with source:'global_cart' — the PDP must not double-fire.

   Overlays.closeCurrent() runs first so any open PDP modal closes and releases the
   PDP's scroll-lock before the drawer takes its own. This preserves the previous
   behaviour where adding to cart closed an open size/info modal, then opened the
   drawer. */
function notifyCartItemAdded() {
  Overlays.closeCurrent();
  document.dispatchEvent(new CustomEvent('cart:item-added'));
}
function openGlobalCart() {
  Overlays.closeCurrent();
  document.dispatchEvent(new CustomEvent('cart:open'));
}

/* ---------------- STICKY BAR ---------------- */
/* Exposed so buildVariants() can call it on color change */
let stickyRefresh = function () {};

function initStickyBar() {
  const bar = $('#stickybar'), atc = $('#atcBtn');
  /* Markup ships aria-hidden="true"; match it in the tab order from the first
     paint, before the IntersectionObserver has fired for the first time. */
  bar.inert = true;
  if (!HAS_SIZE) {
    const ss = $('#stickySize'), sep = $('#stickyMetaSep');
    if (ss) ss.style.display = 'none';
    if (sep) sep.style.display = 'none';
  }

  /* FIX 4: Determine whether the current product is already in the cart.
     Current product handle: window.PDP.handle if set, else derive from P.key. */
  function currentProductHandle() {
    return (window.PDP && window.PDP.handle) || ('auralign-' + P.key);
  }
  function isCurrentProductInCart() {
    if (!state.cart || !state.cart.items) return false;
    const handle = currentProductHandle();
    return state.cart.items.some(item => item.handle === handle);
  }

  function refresh() {
    $('#stickyImg').src = imgW(PLAIN[state.color] || IMAGES[state.color][0], 200);
    $('#stickyFinish').textContent = FINISH_LABEL[state.color];
    if (HAS_SIZE) $('#stickySize').textContent = shortSize(state.size);
    $('#stickyPrice').textContent = money(VARIANTS[state.color].price);

    /* FIX 4: flip sticky button between "Add to Cart" and "View Cart"
       based on live cart state. A single click handler checks state at
       click time — no handler swapping needed, cleaner and race-free. */
    const stickyBtn = $('#stickyAtc');
    const lbl = stickyBtn && stickyBtn.querySelector('.atc__label');
    if (!lbl) return;
    if (isCurrentProductInCart()) {
      lbl.textContent = 'View Cart';
      stickyBtn.classList.add('is-view-cart');
    } else {
      lbl.textContent = 'Add to Cart';
      stickyBtn.classList.remove('is-view-cart');
    }
  }
  /* Expose refresh so buildVariants() can call it on color change */
  stickyRefresh = refresh;

  /* Show/hide (2026-08-16 rewrite): the bar appears ONLY once the buy-box ATC
     button has fully scrolled above the viewport AND the page is genuinely
     scrolled — measured directly from the button's rect on every scroll frame,
     not from possibly-stale IntersectionObserver entries. The old IO-only
     logic could latch "past" off a transient layout shift during load and show
     the bar at page top. */
  let stickyRaf = 0;
  function syncSticky() {
    stickyRaf = 0;
    const r = atc.getBoundingClientRect();
    const past = r.bottom < 0 && window.scrollY > 200;
    if (past === bar.classList.contains('is-on')) return;
    bar.classList.toggle('is-on', past);
    /* Accessibility: announce the sticky bar to screen readers when visible,
       and keep it out of the tab order while hidden — it is only translated
       off-screen, so its controls stayed keyboard-focusable inside an
       aria-hidden container (Lighthouse `aria-hidden-focus`, 2026-08-09 F16). */
    bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    bar.inert = !past;
    if (past) refresh();
  }
  function requestStickySync() {
    if (!stickyRaf) stickyRaf = requestAnimationFrame(syncSticky);
  }
  window.addEventListener('scroll', requestStickySync, { passive: true });
  window.addEventListener('resize', requestStickySync, { passive: true });
  const io = new IntersectionObserver(requestStickySync, { threshold: 0 });
  io.observe(atc);
  syncSticky();

  /* FIX 4: single handler that branches at click time — no handler swap needed. */
  $('#stickyAtc').addEventListener('click', () => {
    refresh();
    if (isCurrentProductInCart()) {
      openGlobalCart();
    } else {
      addRingToCart($('#stickyAtc'));
    }
  });

  const jump = sel => { const el = $(sel); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
  $('#stickyName').addEventListener('click', () => jump('#colorChoices'));
  $('#stickyFinish').addEventListener('click', () => jump('#colorChoices'));
  if (HAS_SIZE) $('#stickySize').addEventListener('click', () => jump('#sizeChoices'));
}

/* ---------------- MODALS ---------------- */
/* Scroll-lock + focus-return are owned by the Overlays registry (top of file).
   W8: syncOverlay() and the shared #overlay backdrop are gone — they existed only
   to back the two private drawers. The modals carry their own backdrop (.modal has
   its own background), so 'modal' is now the registry's only entry. */
function openModal(id, trigger) {
  const m = $(id);
  m.classList.add('is-open');
  m.setAttribute('aria-hidden', 'false');
  Overlays.open('modal', closeModals, trigger);
  const f = m.querySelector('button,a,input,[tabindex]');
  if (f) f.focus();
}
function closeModals() {
  $$('.modal').forEach(m => { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); });
  Overlays.closed('modal');
}
function trapFocus(e) {
  if (e.key !== 'Tab') return;
  const m = $('.modal.is-open');
  if (!m) return;
  const f = [...m.querySelectorAll('button,a[href],input,[tabindex]:not([tabindex="-1"])')].filter(x => x.offsetParent !== null);
  if (!f.length) return;
  const first = f[0], last = f[f.length - 1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
}
function renderExplain(c) {
  const box = $('#infoModalBox');
  let visual;
  if (c.type === 'icon') {
    visual = `<div class="infomodal__visual infomodal__visual--icon"><svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">${c.icon}</svg></div>`;
  } else if (c.type === 'chart') {
    visual = `<div class="infomodal__visual infomodal__visual--illu">${chartSVG()}</div>`;
  } else {
    visual = `<div class="infomodal__visual infomodal__visual--illu">${ILLU[c.illu]}</div>`;
  }
  $('#infoModalVisual').outerHTML = `<div class="infomodal__visual-wrap" id="infoModalVisual">${visual}</div>`;
  $('#infoModalEyebrow').textContent = c.eyebrow || '';
  $('#infoModalEyebrow').style.display = c.eyebrow ? '' : 'none';
  $('#infoModalTitle').innerHTML = c.title;
  $('#infoModalBody').innerHTML = c.body;
  openModal('#infoModal');
}
function openExplain(key) { if (EXPLAIN[key]) renderExplain(EXPLAIN[key]); }
function openBenefit(i) {
  const b = BENEFITS[i];
  renderExplain({ type: 'illu', illu: b.illu, eyebrow: b.k, title: b.t, body: b.body });
}

/* ---------------- PDP BODY WIRING ---------------- */
/* W8: the private header, nav drawer, cart drawer and footer are gone — their
   handlers (cart open/close, burger, mega-menu, newsletter, checkout) went with
   them. The global header/drawer/footer wire themselves from their own sections.
   What stays here is PDP-body wiring only: ATC, modals, reviews jump, Esc. */
function initChrome() {
  $('#atcBtn').addEventListener('click', () => addRingToCart($('#atcBtn')));
  $('#finalAtc').addEventListener('click', () => addRingToCart());
  $('#sizeGuideOpen').addEventListener('click', () => openModal('#sizeModal', $('#sizeGuideOpen')));
  $('#retailInfo').addEventListener('click', () => openExplain('retail'));
  $('#sizeModalClose').addEventListener('click', closeModals);
  $('#infoModalClose').addEventListener('click', closeModals);
  $$('.modal').forEach(m => m.addEventListener('click', e => { if (e.target === m) closeModals(); }));
  $('#ratingLink').addEventListener('click', e => { e.preventDefault(); var rv = document.getElementById('auralign-reviews'); if (rv) rv.scrollIntoView({ behavior: 'smooth' }); });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') Overlays.closeCurrent();
    trapFocus(e);
  });
}

/* ---------------- PER-PRODUCT COPY ---------------- */
function buildCopy() {
  const set = (sel, val) => { const e = $(sel); if (e && val != null) e.textContent = val; };
  set('#pdpEyebrow', P.eyebrow);
  set('#buyboxTitle', P.title);
  set('#buyboxMech', P.blurb);
  set('#benefitsEyebrow', P.benefitsEyebrow);
  set('#benefitsHeading', P.benefitsHeading);
  set('#finalName', P.title);
  set('#stickyName', P.title);
  set('#stickyFinish', FINISH_LABEL[state.color]);
  const rw = $('#retailWas'); if (rw && P.retail) rw.textContent = money(P.retail);
  if (P.science) {
    set('#scienceEyebrow', P.science.eyebrow);
    set('#scienceHeading', P.science.heading);
    set('#scienceLead', P.science.lead);
    const sm = $('#scienceMedia');
    if (sm && P.science.img) { sm.src = imgW(P.science.img, 1200); sm.alt = P.title || ''; }
  }
  const fm = $('#featMedia');
  if (fm && P.featImg) { fm.src = imgW(P.featImg, 1200); fm.alt = P.title || ''; }
  const smb = $('#sizeModalBody');
  if (smb && P.sizeGuide) smb.innerHTML = P.sizeGuide;
  /* Fit row + dispatch line removed 2026-08-16 (Viktor) — fit guidance lives in
     the "Adjustable Fit" accordion, dispatch in Shipping & Returns. */
}

/* ---------------- BUY-BOX RATING CHIP ----------------
   Paint the buy-box stars + "4.6 — N verified reviews" from the SAME aggregate
   the reviews section uses (custom-reviews-aggregate.json, exposed via the
   #auralign-reviews mount's data-agg). Per-product figure where available, else
   the global average. No hardcoded numbers — the chip can never disagree with
   the reviews below it, and never shows invented proof if the fetch fails. */
function hydrateRating() {
  const mount = document.getElementById('auralign-reviews');
  const url = mount && mount.getAttribute('data-agg');
  if (!url) return;
  fetch(url, { credentials: 'same-origin' })
    .then(r => r.json())
    .then(agg => {
      const g = agg.global || {};
      const bp = (agg.by_product || {})[P.key];
      const avg = bp && bp.average ? bp.average : g.average;
      const n = bp && bp.count != null ? bp.count : g.count;
      if (!avg || !n) return;
      const sr = $('#starRow'); if (sr) sr.innerHTML = starRow(avg, 'h');
      const link = $('#ratingLink');
      if (link) link.textContent = avg.toFixed(1) + ' — ' + n.toLocaleString() + ' verified review' + (n === 1 ? '' : 's');
    })
    .catch(() => {});
}

/* ---------------- INIT ---------------- */
document.addEventListener('DOMContentLoaded', () => {
  $('#guaranteeSeal').innerHTML = SEAL_SVG;
  hydrateRating();
  buildCopy();
  buildVariants();
  updatePrice();
  buildGallery();
  initGalleryControls();
  buildTrust();
  buildProofBadge();
  buildBxTabs();
  buildTicker();
  buildAccordion($('#buyAccordion'), BUY_ACCORDION);
  buildUpsell();
  /* Paint the bundle ladder immediately at qty 0 — it must never depend on the
     /cart.js hydration succeeding (the theme-dev proxy can't serve cart
     endpoints, and a failed fetch left the ladder empty — 2026-08-16). */
  refreshBundleUI();
  buildBenefits();
  buildScience();
  buildFAQ();
  buildLifestyle();
  /* Hydrate cart from Shopify on load — renders the real cart state */
  fetchCart();
  initChrome();
  initStickyBar();
  rotateHint();
  /* Eager-3D (2026-08-16): the 360° slide leads the gallery, but the heavy
     ijewel bundle still never loads during the metrics-critical window —
     scheduleViewerBoot() opens the gate on interaction (any device) or
     post-load idle (desktop). Non-eager sessions (saveData / slow link) keep
     the on-reach behaviour via updateGalleryUI. */
  scheduleViewerBoot();
});

/* Open the viewer-boot gate and start the viewer if the shopper is currently
   on the 3D slide (in eager mode that is the landing slide). Triggers:
   - first real interaction anywhere (touch, pointer, scroll, key) — any device
   - post-load idle — desktop only, so mobile Lighthouse/TBT stays clean
   The 1.2 MB bundle + ~17 MB model chain therefore start streaming within a
   second or two of a real visit, but never inside the load-metrics window. */
function scheduleViewerBoot() {
  if (NO_3D || NO_3D_RUNTIME) return;
  let done = false;
  const kick = () => {
    if (done) return;
    done = true;
    cleanup();
    viewerBootAllowed = true;
    const i3d = IDX3D();
    if (EAGER_3D || (i3d !== -1 && state.galleryIndex === i3d)) initViewer();
  };
  const EVENTS = ['pointerdown', 'touchstart', 'scroll', 'keydown', 'pointermove'];
  function cleanup() {
    EVENTS.forEach(ev => window.removeEventListener(ev, kick));
  }
  EVENTS.forEach(ev => window.addEventListener(ev, kick, { once: true, passive: true }));

  const mobile = window.matchMedia('(max-width: 1023px)').matches;
  if (mobile) return; /* mobile waits for the first touch/scroll */
  const onIdle = () => {
    if ('requestIdleCallback' in window) requestIdleCallback(kick, { timeout: 4000 });
    else setTimeout(kick, 1500);
  };
  if (document.readyState === 'complete') onIdle();
  else window.addEventListener('load', onIdle, { once: true });
}

})(); /* end IIFE */
